module.exports = __webpack_public_path__ + "img/progress_097.25e7b1c5.png";